module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAALOzswAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="